import React, { useEffect, useState } from 'react'
import { FirebaseHelper } from '../../firebase-helper';
import Image from '../Image/Image';
import './WallpaperPost.scss';

function WallpaperPost(props) {
    
    return (
        <div className='wp-image '>
            {props.wallpaper&& <Image path="Wallpapers" id={props.wallpaper.id} type="" onClick={props.onClick}/>}
        </div>
    )
}

export default WallpaperPost